import { CdkPortal } from '@angular/cdk/portal';
import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ComponentCanDeactivate } from '@app/core/guards/unsaved-changes.guard';
import { DialogService, FlyoutService } from '@app/core/services';

@Component({
	template: '',
})
export abstract class BaseFlyoutComponent implements ComponentCanDeactivate {
	@ViewChild(CdkPortal) protected portal: CdkPortal;

	abstract canDeactivate: () => boolean;

	constructor(protected readonly flyoutService: FlyoutService, protected readonly dialogService: DialogService) {}

	readonly toggleFlyout = (): void => {
		this.portal.context = { ...this.portal.context, close: this.close, canDeactivate: this.canDeactivate };
		this.flyoutService.toggle(this.portal);
	};

	readonly openFlyout = (): void => {
		this.portal.context = { ...this.portal.context, close: this.close, canDeactivate: this.canDeactivate };
		this.flyoutService.open(this.portal);
	};

	readonly close = (): Subject<boolean> => {
		const closed$ = new Subject<boolean>();

		this.dialogService.canDeactivate(this, {
			onCancel: () => {
				closed$.next(false);
				closed$.complete();
			},
			onCanDeactivate: () => {
				this.flyoutService.close();
				closed$.next(true);
				closed$.complete();
			},
		});

		return closed$;
	};

	protected getPortal(): CdkPortal {
		return this.flyoutService.flyout$?.value ?? this.portal;
	}
}
